<div class="main">
    <div class="container-fluid">
        <!-- Header Section -->
        <div class="bids-header d-flex flex-wrap justify-content-between align-items-center m-4">
            <div class="bids-title-container mb-3 mb-md-0">
                <button class="btn back-btn p-0 mb-2 d-flex align-items-center" (click)="goBack()" aria-label="Go back to Bids">
                    <i class="fas fa-arrow-left me-2"></i>
                    Go back to Bids
                </button>
                <h3>Bid Details - {{ bidDetails?.bidId || bidId }}</h3>
                <span>
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]" class="bids-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <a [routerLink]="['/' + AppConstants.ROUTES.BID]" class="bids-header-title breadcrumb-link">Bids <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <span> View Bids Details</span>
                </span>
            </div>
            <div class="d-flex align-items-center gap-3">
                <button class="export-pdf-btn rounded-pill text-white" (click)="exportPDF()" aria-label="Export PDF">
                    <i class="fas fa-download me-2"></i>
                    Export PDF
                </button>
            </div>
        </div>

        <div class="award-modal-backdrop" *ngIf="showAwardModal" (click)="closeAwardModal()">
            <div class="award-modal" role="dialog" aria-modal="true" aria-labelledby="award-modal-title" (click)="$event.stopPropagation()">
                <div class="award-modal-header">
                    <h5 id="award-modal-title">{{ getAwardActionLabel() }} Vendor</h5>
                    <button type="button" class="btn-close" aria-label="Close" (click)="closeAwardModal()"></button>
                </div>
                <p>Upload the signed {{ getAwardActionLabel().toLowerCase() }} letter for <strong>{{ bidDetails?.bidId }}</strong>. This will regret the other submitted bids for the same tender.</p>
                <label for="award-letter" class="form-label">{{ getAwardActionLabel() }} Letter <span class="text-danger">*</span></label>
                <input id="award-letter" type="file" class="form-control" accept=".pdf,application/pdf" (change)="onAwardLetterSelected($event)">
                <small class="text-muted">PDF only, maximum 5 MB.</small>
                <div class="form-group mt-2">
                    <label for="award-regret-letter" class="form-label mt-3">Regret Letter <span class="text-muted">(optional)</span></label>
                    <input id="award-regret-letter" type="file" class="form-control" accept=".pdf,application/pdf" (change)="onAwardRegretLetterSelected($event)">
                    <small class="text-muted">When provided, this PDF is sent to vendors whose submitted bids are regretted by this award.</small>
                </div>
                <div class="award-modal-actions">
                    <button type="button" class="btn btn-light" (click)="closeAwardModal()">Cancel</button>
                    <button type="button" class="btn award-vendor-btn" [disabled]="!awardLetterFile" (click)="confirmAward()">{{ getAwardActionLabel() }} Bid</button>
                </div>
            </div>
        </div>

        <div class="award-modal-backdrop" *ngIf="showRegretModal" (click)="closeRegretModal()">
            <div class="award-modal" role="dialog" aria-modal="true" aria-labelledby="regret-modal-title" (click)="$event.stopPropagation()">
                <div class="award-modal-header">
                    <h5 id="regret-modal-title">Regret Vendor</h5>
                    <button type="button" class="btn-close" aria-label="Close" (click)="closeRegretModal()"></button>
                </div>
                <p>Upload the signed regret letter for <strong>{{ bidDetails?.bidId }}</strong>. It will be attached to the vendor email.</p>
                <label for="regret-letter" class="form-label">Regret Letter <span class="text-danger">*</span></label>
                <input id="regret-letter" type="file" class="form-control" accept=".pdf,application/pdf" (change)="onRegretLetterSelected($event)">
                <small class="text-muted">PDF only, maximum 5 MB.</small>
                <div class="award-modal-actions">
                    <button type="button" class="btn btn-light" (click)="closeRegretModal()">Cancel</button>
                    <button type="button" class="btn regret-vendor-btn" [disabled]="!regretLetterFile" (click)="confirmRegret()">Regret Vendor</button>
                </div>
            </div>
        </div>

        <div class="bid-page-message m-4" *ngIf="!bidDetails && getBidErrorMessage()">
            <div class="bid-error-message">
                <p class="error-message-text">
                    <i class="fas fa-exclamation-circle me-2"></i>
                    {{ getBidErrorMessage() }}
                </p>
            </div>
        </div>

        <div class="bid-page-message m-4" *ngIf="!bidDetails && !getBidErrorMessage()">
            <p class="text-muted mb-0">No bid details available.</p>
        </div>

        <!-- Main Content Card -->
        <div class="mandatory-application m-4" *ngIf="bidDetails">
            <div class="inside-out p-4">
                <div class="mandatory-fields"></div>
                <div class="container pt-4">
                    <!-- Bid Information Section -->
                    <fieldset class="content-fieldset mb-4">
                        <legend class="section-legend legend-with-buttons">
                            <span>Bid Information</span>
                            <div class="action-buttons-row d-flex gap-2 flex-wrap" *ngIf="canManageBidDecision() || canVerifyJoiningFeePayment()">
                                <button class="btn award-vendor-btn" *ngIf="canVerifyJoiningFeePayment()" (click)="verifyJoiningFeePayment()">
                                    Verify Payment
                                </button>
                                <button class="btn award-vendor-btn" *ngIf="canManageBidDecision()" (click)="awardVendor()">
                                    {{ getAwardActionLabel() }} Vendor
                                </button>
                                <button class="btn regret-vendor-btn" *ngIf="canManageBidDecision()" (click)="regretVendor()">
                                    Regret Vendor
                                </button>
                            </div>
                        </legend>
                        <div class="bid-error-message mb-3" *ngIf="bidDetails && getBidErrorMessage()">
                            <p class="error-message-text">
                                <i class="fas fa-exclamation-circle me-2"></i>
                                {{ getBidErrorMessage() }}
                            </p>
                        </div>
                        <div class="bid-info-section row">
                        <div class="col-md-6">
                            <div class="info-item mb-3">
                                <p class="fw-bold mb-1">Bid ID:</p>
                                <p class="light-text-m">{{ bidDetails.bidId }}</p>
                            </div>
                            <div class="info-item mb-3">
                                <p class="fw-bold mb-1">Vendor:</p>
                                <p class="light-text-m">
                                    <!-- <a *ngIf="bidDetails.vendorId" (click)="viewVendor(bidDetails.vendorId)" class="vendor-link">{{ bidDetails.vendor }}</a> -->
                                    <span *ngIf="bidDetails.vendorId">{{ bidDetails.vendor }}</span>
                                </p>
                            </div>
                            <div class="info-item mb-3">
                                <p class="fw-bold mb-1">Contact Person:</p>
                                <p class="light-text-m">{{ bidDetails.contactPerson }}</p>
                            </div>
                            <div class="info-item mb-3">
                                <p class="fw-bold mb-1">Contact Phone:</p>
                                <p class="light-text-m">{{ bidDetails.contactPhone }}</p>
                            </div>
                            <div class="info-item mb-3" *ngIf="bidDetails.deliveryPeriod">
                                <p class="fw-bold mb-1">Delivery Period:</p>
                                <p class="light-text-m">{{ bidDetails.deliveryPeriod }}</p>
                            </div>
                            <div class="info-item mb-3" *ngIf="bidDetails.paymentTerms">
                                <p class="fw-bold mb-1">Payment Terms:</p>
                                <p class="light-text-m">{{ bidDetails.paymentTerms }}</p>
                            </div>
                            <div class="info-item mb-3">
                                <p class="fw-bold mb-1">Status:</p>
                                <app-status-badge 
                                    [text]="bidDetails.status"
                                    [color]="getStatusColor(bidDetails.status)"
                                    [size]="'small'">
                                </app-status-badge>
                            </div>
                            <ng-container *ngIf="isPaymentVerificationPending()">
                                <div class="info-item mb-3" *ngIf="bidDetails.joiningFee !== null && bidDetails.joiningFee !== undefined">
                                    <p class="fw-bold mb-1">Joining Fee:</p>
                                    <p class="light-text-m">{{ bidDetails.joiningFee | number: '1.2-2' }}</p>
                                </div>
                                <div class="info-item mb-3" *ngIf="bidDetails.paymentReferenceNumber">
                                    <p class="fw-bold mb-1">Payment Reference:</p>
                                    <p class="light-text-m">{{ bidDetails.paymentReferenceNumber }}</p>
                                </div>
                                <div class="info-item mb-3" *ngIf="bidDetails.bankName">
                                    <p class="fw-bold mb-1">Bank:</p>
                                    <p class="light-text-m">{{ bidDetails.bankName }}</p>
                                </div>
                                <div class="info-item mb-3" *ngIf="bidDetails.accountNumber">
                                    <p class="fw-bold mb-1">Account Number:</p>
                                    <p class="light-text-m">{{ bidDetails.accountNumber }}</p>
                                </div>
                                <div class="info-item mb-3" *ngIf="bidDetails.paymentDate">
                                    <p class="fw-bold mb-1">Payment Date:</p>
                                    <p class="light-text-m">{{ bidDetails.paymentDate | date: 'yyyy-MM-dd' }}</p>
                                </div>
                            </ng-container>
                            <div class="info-item mb-3" *ngIf="bidDetails.tcCommitteeStatus">
                                <p class="fw-bold mb-1">Committee Status:</p>
                                <app-status-badge
                                    [text]="bidDetails.tcCommitteeStatus"
                                    [color]="getStatusColor(bidDetails.tcCommitteeStatus)"
                                    [size]="'small'">
                                </app-status-badge>
                            </div>
                            <div class="info-item mb-3 d-none" *ngIf="bidDetails.awardDecision">
                                <p class="fw-bold mb-1">Award Decision:</p>
                                <app-status-badge 
                                    [text]="bidDetails.awardDecision"
                                    [color]="getAwardDecisionColor(bidDetails.awardDecision)"
                                    [size]="'small'">
                                </app-status-badge>
                            </div>
                    </div>
                        <div class="col-md-6">
                            <div class="info-item mb-3">
                                <p class="fw-bold mb-1">Tender ID:</p>
                                <p class="light-text-m">
                                    <a [routerLink]="['/' + AppConstants.ROUTES.TENDER + '/' + AppConstants.ROUTES.TENDERDETAILS + '/' + bidDetails.tenderId]" class="tender-link">{{ bidDetails.tenderId }}</a>
                                </p>
                            </div>
                            <div class="info-item mb-3">
                                <p class="fw-bold mb-1">Submission Date:</p>
                                <p class="light-text-m">{{ bidDetails.submissionDate | date: 'yyyy-MM-dd' }}</p>
                            </div>
                            <div class="info-item mb-3">
                                <p class="fw-bold mb-1">Contact Email:</p>
                                <p class="light-text-m">{{ bidDetails.contactEmail }}</p>
                            </div>
                            <div class="info-item mb-3">
                                <p class="fw-bold mb-1">Bid Value (QAR):</p>
                                <p class="light-text-m">{{ bidDetails.bidValue | number: '1.0-0' }}</p>
                            </div>
                             <div class="info-item mb-3" *ngIf="bidDetails.warrantyPeriod">
                                <p class="fw-bold mb-1">Warranty Period:</p>
                                <p class="light-text-m">{{ bidDetails.warrantyPeriod }}</p>
                            </div>
                            <div class="info-item mb-3" *ngIf="bidDetails.evaluationType">
                                <p class="fw-bold mb-1">Evaluation Type:</p>
                                <app-status-badge 
                                    [text]="bidDetails.evaluationType"
                                    [color]="getEvaluationTypeColor(bidDetails.evaluationType)"
                                    [size]="'small'">
                                </app-status-badge>
                            </div>
                        </div>
                        </div>
                    </fieldset>

                    <fieldset class="content-fieldset mb-4" *ngIf="evaluationResults.length">
                        <legend class="section-legend">Evaluation Results</legend>
                        <div class="table-responsive">
                            <table class="table evaluation-results-table mb-0">
                                <thead>
                                    <tr>
                                        <th>Evaluation ID</th>
                                        <th>Type</th>
                                        <th>Evaluation Status</th>
                                        <th>Decision</th>
                                        <th>Remarks</th>
                                        <th>Decision Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let result of evaluationResults">
                                        <td>{{ result.evaluationId }}</td>
                                        <td><app-status-badge [text]="result.evaluationType" [color]="getEvaluationTypeColor(result.evaluationType)" [size]="'small'"></app-status-badge></td>
                                        <td><app-status-badge [text]="result.evaluationStatus" [color]="getStatusColor(result.evaluationStatus)" [size]="'small'"></app-status-badge></td>
                                        <td><app-status-badge [text]="result.decision" [color]="getEvaluationDecisionColor(result.decision)" [size]="'small'"></app-status-badge></td>
                                        <td>{{ result.rejectionReason || result.comments || '-' }}</td>
                                        <td>{{ result.decisionDate ? (result.decisionDate | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </fieldset>

                    <!-- Bid Documents Section -->
                    <fieldset class="content-fieldset mb-4">
                        <legend class="section-legend">Bid Documents</legend>
                        <div class="documents-section">
                            <div class="document-category" *ngFor="let group of bidAttachmentGroups">
                                <h5 class="document-category-title">{{ group.category }}</h5>
                                <div class="document-item d-flex justify-content-between align-items-center p-3 mb-3" *ngFor="let attachment of group.attachments; trackBy: trackByAttachment">
                                    <div class="d-flex align-items-center flex-grow-1">
                                        <div class="document-icon me-3">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12.5007 1.66675H5.00065C4.55862 1.66675 4.1347 1.84234 3.82214 2.1549C3.50958 2.46746 3.33398 2.89139 3.33398 3.33341V16.6667C3.33398 17.1088 3.50958 17.5327 3.82214 17.8453C4.1347 18.1578 4.55862 18.3334 5.00065 18.3334H15.0007C15.4427 18.3334 15.8666 18.1578 16.1792 17.8453C16.4917 17.5327 16.6673 17.1088 16.6673 16.6667V5.83341L12.5007 1.66675Z" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M11.666 1.66675V5.00008C11.666 5.44211 11.8416 5.86603 12.1542 6.17859C12.4667 6.49115 12.8907 6.66675 13.3327 6.66675H16.666" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.33268 7.5H6.66602" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M13.3327 10.8333H6.66602" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M13.3327 14.1667H6.66602" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                        <div class="document-info flex-grow-1" *ngIf="!isAttachmentSealed(attachment); else sealedDocumentLabel">
                                            <div class="document-name fw-bold mb-1">{{ attachment.name }}</div>
                                            <div class="document-meta d-flex gap-3">
                                                <span class="document-size light-text-m">{{ attachment.sizeFormatted }}</span>
                                                <span class="document-date light-text-m" *ngIf="attachment.date">Uploaded {{ attachment.date | date: 'yyyy-MM-dd' }}</span>
                                                <span class="document-date light-text-m" *ngIf="attachment.documentExpiryDate">Expires {{ attachment.documentExpiryDate | date: 'yyyy-MM-dd' }}</span>
                                            </div>
                                        </div>
                                        <ng-template #sealedDocumentLabel>
                                            <div class="document-info sealed-document-info flex-grow-1">
                                                <div class="document-name fw-bold mb-1">Document sealed</div>
                                                <div class="document-meta d-flex gap-3">
                                                    <span class="document-date light-text-m" *ngIf="attachment.documentExpiryDate">Expires {{ attachment.documentExpiryDate | date: 'yyyy-MM-dd' }}</span>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                    <button *ngIf="canDownloadAttachment(attachment)" class="btn download-btn" (click)="downloadAttachment(attachment)">
                                        Download
                                    </button>
                                </div>
                            </div>

                            <div *ngIf="bidAttachmentGroups.length === 0" class="no-documents p-3">
                                <p class="text-muted mb-0">No documents available</p>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</div>

